import { createFileRoute } from "@tanstack/react-router";
import { ContractComparisonsPage } from "@/features/contracts/contract-comparisons-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/porownanie/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.porownanie",
			location.pathname,
		);
	},
	component: ContractComparisonsPage,
});
